import { BASE, authHeaders } from './assetManagerApi.js'

export function gameableDescriptorUrl(character, base) {
  return `${base.replace(/\/+$/, '')}/api/characters/${encodeURIComponent(character.id)}/ogs/character.json`
}

export function createAamBundleFetch({ base, headers, fetchImpl = fetch }) {
  const originBase = new URL(base, globalThis.location?.href)
  return (input, init = {}) => {
    const url = new URL(input instanceof Request ? input.url : input, globalThis.location?.href ?? originBase.href)
    // Compare parsed origins: a string prefix would also trust look-alike hosts.
    const trusted = url.origin === originBase.origin && url.pathname.startsWith(originBase.pathname)
    if (!trusted) return fetchImpl(input, init)
    const merged = new Headers(input instanceof Request ? input.headers : undefined)
    new Headers(headers).forEach((value, key) => merged.set(key, value))
    new Headers(init.headers).forEach((value, key) => merged.set(key, value))
    // Cookies too, like apiClient's AAM calls, but only to the asset manager.
    return fetchImpl(input, { credentials: 'include', ...init, headers: merged })
  }
}

export async function loadGameableForGass(renderer, character, { signal, base = BASE, headers = authHeaders(), fetchImpl = fetch } = {}) {
  // Keep the character runtime out of the initial viewer download.
  const { loadGameableCharacter } = await import('gameable/three')
  signal?.throwIfAborted()
  const url = new URL(gameableDescriptorUrl(character, base), globalThis.location?.href).href
  return loadGameableCharacter(renderer, url, {
    clip: 'idle', signal, fetch: createAamBundleFetch({ base, headers, fetchImpl }),
  })
}
